module.exports = __webpack_public_path__ + "img/Kodefast-Loading-Animation.89ba0847.gif";